// Form validation utilities

export const validateRequired = (value: string): boolean => {
  return value.trim().length > 0;
};

export const validateMinLength = (value: string, minLength: number): boolean => {
  return value.trim().length >= minLength;
};

export const validateEmail = (value: string): boolean => {
  if (!value) return true; // optional field
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const validateUrl = (value: string): boolean => {
  if (!value) return true; // optional field
  try {
    const url = value.startsWith('http') ? value : `https://${value}`;
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const validateNumber = (value: string): boolean => {
  if (!value) return true; // optional field
  const num = Number(value.replace(/[,$]/g, ''));
  return !isNaN(num) && num >= 0;
};

export const validateYear = (value: string): boolean => {
  if (!value) return true;
  const year = Number(value);
  const currentYear = new Date().getFullYear();
  return !isNaN(year) && year >= 1900 && year <= currentYear;
};
